import { techDocs } from "../technical-docs";

export default techDocs('accessibility', 'Acessibilidade', 'documentos-tecnicos-acessibilidade')